import Cookies from 'js-cookie'
import BaseConfig from '@/config/base.js'
import SecretKey from '@/config/secret-key.js'

import { Toast } from 'vant'
import { decryptCode, getQueryParam, createDeviceId } from '@/utils/common.js'
import { mockFlag, mockApp, appNameFlag, domainNameFlag } from '@/commonFunc/judge-package-name.js'

export default {
  // 立即执行 和global-mixin.js 中的env有区别
  env: (function () {
    const ua = navigator.userAgent
    return {
      // ua在app内 值是dq
      ua: ua,
      // app内可判断
      isApp: /dq/i.test(ua),
      isBrowser: !/dq/i.test(ua),
      // app外可判断
      isMobile: /android|iphone|ipod|ipad/i.test(ua),
      isIOS: /iphone|ipod|ipad|ios|mac os/i.test(ua),
      isAndroid: /android/i.test(ua),
    }
  })(),

  // 判断语言-链接
  getLangFromUrl(url) {
    if (url.indexOf('lang') > 0) {
      const queryLang = url.substring(url.indexOf('lang='), url.indexOf('lang=') + 7)
      const urlLang = queryLang.substr(queryLang.indexOf('=') + 1)
      return urlLang
    }
    return 'en'
  },

  // 获取包信息
  getAppInfo() {
    // app内
    if (this.env.isApp) {
      const appInfo = Cookies.get('UserInfo')
      return appInfo ? eval('(' + appInfo + ')') : {}
    }
    // 非app内
    else {
      let deviceId = ''
      let appPackageName = ''
      let channel = ''

      // 浏览器环境 仅为sayHi活动-浏览器登陆状态 使用
      if (this.env.isBrowser) {
        try {
          let da = getQueryParam(window.location.href, 'da')
          da = decodeURIComponent(da)
          let strObj = decryptCode(da, SecretKey.uploadCodePri)
          if (strObj) {
            strObj = JSON.parse(strObj)
          }
          if (strObj) {
            deviceId = strObj.deviceId
            appPackageName = strObj.appPackageName
          }

          // 为签名用(没有的话随机生成一个)
          if (!deviceId) {
            deviceId = createDeviceId()
          }
        } catch (err) {
          console.log('try catch', err)
        }
      }

      // localhsot-调试
      if (window.location.hostname === 'localhost') {
        deviceId = '9b7cdeac-9ea6-4467-b9c9-d94bdc690d4d'
        appPackageName = 'com.example.gcc'
        channel = 'vvg'
      }

      return {
        language: this.getLangFromUrl(window.location.hash),
        deviceId: deviceId,
        appPackageName: appPackageName,
        channel: channel,
      }
    }
  },

  // 获取用户id和token
  getUserBaseInfo() {
    // app内
    if (this.env.isApp) {
      let uid = ''
      let token = ''
      let userInfo = Cookies.get('UserInfo')
      if (userInfo) {
        userInfo = eval('(' + userInfo + ')')
        uid = userInfo['uid']
        token = userInfo['token']
      }
      return {
        uid: uid,
        token: token,
      }
    }
    // 非app内
    else {
      // 好友
      // 1079 -> 2507

      let uid = ''
      let token = ''

      if (this.env.isBrowser) {
        try {
          let ut = getQueryParam(window.location.href, 'ut')
          ut = decodeURIComponent(ut)
          let strObj = decryptCode(ut, SecretKey.uploadCodePri)
          if (strObj) {
            strObj = JSON.parse(strObj)
          }
          if (strObj) {
            uid = strObj.uid
            token = strObj.token
          }
        } catch (err) {
          console.log('try catch', err)
        }
      }

      // localhsot-调试代码
      // 2507 -> 41944 好友
      if (window.location.hostname === 'localhost') {
        uid = '2507'
        token = 'c281f3e7e17440ddae826017cddf0b1d'

        // uid = '1079'
        // token = '6ea8dc8086cb4aafbcce313c8fc4d77a'
      }

      return {
        uid: uid,
        token: token,
      }
    }
  },

  // 获取包信息中的语言(优先取app设置的language 如果值为auto 则取系统language)
  getAppInfoLang() {
    // app内
    if (this.env.isApp) {
      const appInfo = Cookies.get('UserInfo')
      const obj = appInfo ? eval('(' + appInfo + ')') : null
      if (obj !== null && Object.keys(obj).length > 0) {
        if (obj.appLanguage) {
          return obj.appLanguage == 'auto' ? obj.language : obj.appLanguage
        }
        return obj.language
      }
    }
    // 非app内
    else {
      return this.getLangFromUrl(window.location.hash)
    }
  },

  // 获取包信息中的包名
  getPackageShortName() {
    let packageShortName = ''

    // app内
    if (this.env.isApp) {
      const appInfo = Cookies.get('UserInfo')
      const appObj = appInfo ? eval('(' + appInfo + ')') : null
      if (appObj !== null && Object.keys(appObj).length > 0) {
        if (appObj.appPackageName) {
          for (let i = 0; i < BaseConfig.validAppPackage.length + 1; i++) {
            const shortName = BaseConfig.validAppPackage[i]
            if (appNameFlag(shortName, appObj.appPackageName)) {
              packageShortName = shortName
              break
            }
          }
        }
      }
    }
    // 非app内
    else {
      for (let i = 0; i < BaseConfig.validAppPackage.length + 1; i++) {
        const shortName = BaseConfig.validAppPackage[i]
        if (domainNameFlag(shortName, window.location.hostname)) {
          packageShortName = shortName
          break
        }
      }
    }
    // localhsot-调试代码
    if (window.location.hostname === 'localhost') {
      packageShortName = mockFlag ? mockApp : 'vava'
    }

    return packageShortName
  },

  // 提示消息
  showToast(message) {
    const showVantToast = () => Toast({ message, duration: 3000 })
    try {
      if (!this.env.isApp) {
        showVantToast()
        return
      }
      const appInfo = this.getAppInfo()
      const useIosBridge = this.env.isIOS || String(appInfo.deviceType) === '1'
      const iosHandler = window.webkit?.messageHandlers?.showToast
      if (useIosBridge && iosHandler) {
        iosHandler.postMessage(message)
        return
      }
      const androidBridge = globalThis.showToast
      if (typeof androidBridge?.postMessage === 'function') {
        androidBridge.postMessage(message)
        return
      }
      showVantToast()
    } catch (err) {
      console.log('try catch', err)
      try {
        showVantToast()
      } catch (_) {}
    }
  },

  // 关闭webview
  closeActivity() {
    closeActivity.postMessage('')
  },

  // 关闭iOS页面
  closeActivityIOS() {
    window.webkit.messageHandlers.closeActivity.postMessage(null)
  },

  // 给客户端传参数
  googleProductList(list, packageName) {
    try {
      // echo包通道
      if (packageName === 'echo') {
        queryProductList.postMessage(JSON.stringify(list))
      }
      // 其它包通道
      else {
        queryGoogleProductList.postMessage(JSON.stringify(list))
      }
    } catch (err) {
      console.log('try catch', err)
    }
  },

  // 拷贝链接
  copyLink(link, msg) {
    Vue.prototype.$copyText(link).then((e) => {
      if (e) {
        if (msg) {
          this.showToast(msg)
        }
      }
    })
  },

  // 埋点
  addEvent(event, param) {
    try {
      if (this.env.isApp) {
        const params = {
          eventName: event,
          param: param,
        }
        addEvent.postMessage(JSON.stringify(params))
      }
    } catch (err) {
      console.log('try catch', err)
    }
  },
}
